module.exports = __webpack_public_path__ + "img/poly-5.8d7e35c8.png";